module.exports = "/_next/static/images/search_bg_28-2929657bacf962047fdc13274740618e.jpg";